"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaApplicationErrorCode = void 0;
var CaptchaApplicationErrorCode;
(function (CaptchaApplicationErrorCode) {
    CaptchaApplicationErrorCode["CaptchaRequired"] = "CAPTCHA_REQUIRED";
    CaptchaApplicationErrorCode["CaptchaAssessmentFailed"] = "CAPTCHA_ASSESSMENT_FAILED";
})(CaptchaApplicationErrorCode = exports.CaptchaApplicationErrorCode || (exports.CaptchaApplicationErrorCode = {}));
//# sourceMappingURL=CaptchaApplicationErrorCode.js.map